import React, { useState } from "react";
import Text from "../../text/Text";
import Modal from "../../modal/Modal";
import Icon from "../../icon/Icon";
import { MdHelp } from "react-icons/md";
export default function SubscriptionInfoModal(_a) {
    var size = _a.size;
    var _b = useState(false), isSubscriptionModalOpen = _b[0], setIsSubscriptionModalOpen = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Icon, { size: size, color: "#949494", icon: MdHelp, ariaLabel: "Subscription Info", ml: 1, onClick: function () {
                setIsSubscriptionModalOpen(true);
            } }),
        React.createElement(Modal, { title: "Subscribe & Save", isOpen: isSubscriptionModalOpen, onRequestClose: function () { return setIsSubscriptionModalOpen(false); } },
            React.createElement(Text, { mb: 5, display: "block" }, "With a subscription, you'll get your favorite Onnit products whenever you want at 15% off MSRP. All automatic, worry free, and with our same great money back guarantee."),
            React.createElement(Text, { mb: 5, display: "block", fontSize: 1 },
                "Cancel or adjust your order at any time, hassle free. Your payment method will only be charged right before your order ships. The discount applied every time is 15% off MSRP or the current sale discount, whichever is greater. For more information, see the complete Onnit",
                " ",
                React.createElement(Text, { as: "a", fontSize: 1, href: "/terms-and-conditions/subscription/#terms", display: "inline" }, "Subscription Terms & Conditions"),
                " ",
                "and",
                " ",
                React.createElement(Text, { as: "a", fontSize: 1, href: "/terms-and-conditions/subscription/#faq", display: "inline" }, "Frequently Asked Questions"),
                "."))));
}
//# sourceMappingURL=SubscriptionInfoModal.js.map